import { Box, Typography } from "@mui/material";
import { GiftCardData } from "../data/shared";
import { ScopeType } from "../enums";
import { useAuthContext } from "../contexts";
export const defaultImage = "https://storagesuregiftsdev.blob.core.windows.net/store-images/Default_Gift_Image.jpg";
type GiftCardViewProps = {
  gift: GiftCardData;
  onClick?: () => void;
  selected?: boolean;
};
export const GiftCardView = ({ gift: { imageUrl, name, paymentMargin }, selected = false, onClick = () => {} }: GiftCardViewProps) => {
  const { user } = useAuthContext();
  return (
    <Box
      onClick={() => onClick()}
      sx={{
        overflow: "hidden",
        maxWidth: "17.5rem",
        height: "16.375rem",
        boxSizing: "border-box",
        padding: "1.875rem",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        cursor: "pointer",
        backgroundImage: "url(/assets/images/gift-bg.png)",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "&:hover": {
          backgroundImage: "url(/assets/images/gift-bg-hover.png)",
        },
        ...(selected && {
          backgroundImage: "url(/assets/images/gift-bg-hover.png)",
        }),
      }}
    >
      <Typography sx={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", fontWeight: 700 }}>{name}</Typography>
      <div
        style={{
          position: "relative",
        }}
      >
        {user?.scopeId === ScopeType.Site && paymentMargin > 0 && (user as any).hasDiscount && (
          <Box
            component={"span"}
            sx={{
              position: "absolute",
              backgroundColor: "#3DC16B",
              fontWeight: 500,
              lineHeight: "23px",
              padding: "8px",
              borderRadius: "50vh",
              borderBottomLeftRadius: "0",
              left: "-10px",
              top: "-10px",
            }}
          >
            {paymentMargin}% off
          </Box>
        )}
        <Box component={"img"} sx={{ height: "8.8125rem", width: "13.75rem", maxWidth: "100%", borderRadius: "0.625rem", objectFit: "cover" }} src={imageUrl || defaultImage}></Box>
      </div>
    </Box>
  );
};
